// removed by extract-text-webpack-plugin
module.exports = {"textarea-wrapper":"LongTextField__textarea-wrapper___2nXrk","error":"LongTextField__error___vUNFa","long-text-answers":"LongTextField__long-text-answers___3oYWg"};